import KidInformations from "./KidInformations.jsx";

export default KidInformations;
